// extracted by mini-css-extract-plugin
export var inlineLink = "_5w-0";
export var inlineLinkButton = "_5w-1";